<div class="propensity-scoring-manager p-4">
    <!-- Header -->
    <div class="flex justify-between items-center mb-4">
        <div>
            <h3 class="text-lg font-semibold">Propensity-Bewertung</h3>
            <p class="text-sm text-gray-500" *ngIf="campaignName">Kampagne: {{ campaignName }}</p>
        </div>
        <div class="flex gap-2 items-center">
            <p-select
                [(ngModel)]="selectedModelId"
                [options]="activeModels"
                optionLabel="name"
                optionValue="id"
                placeholder="Modell auswählen"
                [style]="{'min-width': '200px'}">
            </p-select>
            <button
                pButton
                type="button"
                label="Bewertung starten"
                icon="fa-solid fa-play"
                [loading]="scoringInProgress"
                [disabled]="!selectedModelId || scoringInProgress"
                (click)="executeScoring()">
            </button>
        </div>
    </div>

    <!-- Error Message -->
    <p-message
        *ngIf="error"
        severity="error"
        [text]="error"
        [closable]="true"
        (onClose)="clearError()"
        class="mb-4">
    </p-message>

    <!-- Tabs -->
    <p-tabs [(value)]="activeTab">

        <!-- ================= TAB HEADERS ================= -->
        <p-tablist>
            <p-tab [value]="PropensityTab.Overview">Übersicht</p-tab>
            <p-tab [value]="PropensityTab.Members">Mitglieder nach Bewertung</p-tab>
            <p-tab [value]="PropensityTab.History">Bewertungsverlauf</p-tab>
        </p-tablist>

        <!-- ================= TAB PANELS ================= -->
        <p-tabpanels>

            <!-- ===== OVERVIEW ===== -->
            <p-tabpanel [value]="PropensityTab.Overview">

                <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6" *ngIf="campaignStats">
                    <div class="p-card" *ngFor="let stat of [
                    { label: 'Bewertete Mitglieder', value: campaignStats.membersWithScores }
                ]">
                        <div class="p-4 text-center">
                            <div class="text-2xl font-bold">{{ stat.value }}</div>
                            <div class="text-sm text-gray-500">{{ stat.label }}</div>
                        </div>
                    </div>
                </div>

                <div class="p-card mb-6" *ngIf="scoreDistribution">
                    <div class="p-4">
                        <h4 class="font-semibold mb-4">Bewertungsverteilung</h4>
                        <div class="h-8 flex rounded overflow-hidden">
                            <div class="bg-green-500" [style.width.%]="scoreDistribution.highTier?.percentage || 0"></div>
                            <div class="bg-yellow-500" [style.width.%]="scoreDistribution.mediumTier?.percentage || 0"></div>
                            <div class="bg-red-500" [style.width.%]="scoreDistribution.lowTier?.percentage || 0"></div>
                        </div>
                    </div>
                </div>

            </p-tabpanel>

            <!-- ===== MEMBERS ===== -->
            <p-tabpanel [value]="PropensityTab.Members">

                <div class="flex gap-4 mb-4">
                    <p-select
                            [(ngModel)]="selectedTierFilter"
                            [options]="tierFilters"
                            optionLabel="label"
                            optionValue="value"
                            (onChange)="onTierFilterChange()">
                    </p-select>

                    <button
                            pButton
                            class="p-button-outlined"
                            (click)="toggleSortOrder()">
                        {{ sortDescending ? 'Höchste zuerst' : 'Niedrigste zuerst' }}
                    </button>
                </div>

                <p-table [value]="scoredMembers" [loading]="loading" [paginator]="true" [rows]="20">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Mitglieds-ID</th>
                            <th>Bewertung</th>
                            <th>Stufe</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-member>
                        <tr (click)="onMemberClick(member)" class="cursor-pointer">
                            <td>{{ member.memberId }}</td>
                            <td>{{ formatScore(member.propensityScore) }}</td>
                            <td>{{ member.scoreTier }}</td>
                        </tr>
                    </ng-template>
                </p-table>

            </p-tabpanel>

            <!-- ===== HISTORY ===== -->
            <p-tabpanel [value]="PropensityTab.History">

                <p-table [value]="scoringRuns" [paginator]="true" [rows]="10">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>ID</th>
                            <th>Status</th>
                            <th>Gestartet</th>
                            <th>Abgeschlossen</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-run>
                        <tr>
                            <td>{{ run.id }}</td>
                            <td>
                            <span [ngClass]="getRunStatusClass(run.status)">
                                {{ run.status }}
                            </span>
                            </td>
                            <td>{{ formatDate(run.startedAt) }}</td>
                            <td>{{ formatDate(run.completedAt) }}</td>
                        </tr>
                    </ng-template>
                </p-table>

            </p-tabpanel>

        </p-tabpanels>
    </p-tabs>

</div>
